import React, { useState } from "react";
import Title from "../layouts/Title";
// import Education from "./Education"; // Disabled for now
import Skills from "./Skills";
import Certifications from "./Certifications";

const Resume = () => {
  // Default: Professional Skills active
  const [skillData, setSkillData] = useState(true);
  const [certificationData, setCertificationData] = useState(false);

  return (
    <section
      id="resume"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="4+ YEARS OF EXPERIENCE" des="My Resume" />
      </div>

      {/* ================= Resume Buttons ================= */}
      <div>
        {/* ⬇️ Changed grid to 2 columns */}
        <ul className="w-full grid grid-cols-1 md:grid-cols-2">

          {/* Professional Skills */}
          <li
            onClick={() => {
              setSkillData(true);
              setCertificationData(false);
            }}
            className={`${
              skillData
                ? "border-designColor rounded-lg"
                : "border-transparent"
            } resumeLi`}
          >
            Professional Skills
          </li>

          {/* Certifications */}
          <li
            onClick={() => {
              setSkillData(false);
              setCertificationData(true);
            }}
            className={`${
              certificationData
                ? "border-designColor rounded-lg"
                : "border-transparent"
            } resumeLi`}
          >
            Certifications
          </li>

          {/* ================= EDUCATION BUTTON (DISABLED) ================= */}
          {/*
          <li>Education</li>
          */}

        </ul>
      </div>

      {/* ================= Resume Sections ================= */}
      {skillData && <Skills />}
      {certificationData && <Certifications />}

      {/* ================= EDUCATION SECTION (DISABLED) ================= */}
      {/*
      <Education />
      */}

    </section>
  );
};

export default Resume;
